import { render } from "./Profile.vue?vue&type=template&id=ca123f88"
import script from "./Profile.vue?vue&type=script&lang=js"
export * from "./Profile.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/auth/Profile.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "ca123f88"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('ca123f88', __exports__)) {
    console.log('reload')
    api.reload('ca123f88', __exports__)
  }
  
  module.hot.accept("./Profile.vue?vue&type=template&id=ca123f88", () => {
    console.log('re-render')
    api.rerender('ca123f88', render)
  })

}


export default __exports__